import { createSlice } from '@reduxjs/toolkit'

const initialState = 'zh'

export const lngSlice = createSlice({
  name: 'lng',
  initialState,
  reducers: {
    setIntl: (state, action) => {
      return action.payload
    },
  },
})

export const { setIntl } = lngSlice.actions
export default lngSlice.reducer
